import defaultAttributes from '../defaultAttributes';

const FileCheck = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
    ],
    ['polyline', { points: '14 2 14 8 20 8' }],
    ['path', { d: 'M9 15l2 2 4-4' }],
  ],
];

export default FileCheck;
